import React from 'react';
import Logo from 'components/common/logo';
import parent from 'style/imgs/parent.svg';
import teacher from 'style/imgs/teacher.svg';
import { Link, useHistory } from 'react-router-dom';
import { logEvent } from 'services/amplitude';

import buttons from 'style/buttons.module.scss';
import styles from './index.module.scss';

const ChooseRole: React.FC = () => {
  const history = useHistory();
  return (
    <div className={styles.chooseRole}>
      <div className={styles.logo}>
        <Logo />
      </div>
      <h1 className="deep-gray-heading">I&apos;d like to join as a...</h1>
      <div className={styles.selectBlock}>
        <Link
          to={{ pathname: '/welcome', state: { role: 'Parent' } }}
          className={styles.selectBlockItem}
          onClick={() => logEvent('ParentSignUp')}
        >
          <div>
            <div>
              <img src={parent} alt="parent" />
            </div>
            <span>Educator or Parent</span>
          </div>
        </Link>
        <Link
          to={{ pathname: '/welcome', state: { role: 'Teacher' } }}
          className={styles.selectBlockItem}
          onClick={() => logEvent('TeacherSignUp')}
        >
          <div>
            <div>
              <img src={teacher} alt="teacher" />
            </div>
            <span>Curator</span>
          </div>
        </Link>
      </div>
      <h2>
        Aneta is a graphics-based digital organization and wayfinding solution
        for scholars of any age.
      </h2>
      <p>Already a member?</p>
      <button
        type="button"
        onClick={() => history.push('/login/')}
        className={buttons.buttonOrange}
      >
        Login
      </button>
      <span>
        Learn more about Aneta{' '}
        <a href="https://anetaed.com/" target="_blank" rel="noreferrer">
          here
        </a>
      </span>
    </div>
  );
};

export default ChooseRole;
